import { AddingExperience } from "@/types/experiences";
import { formatImageUrl } from "@/lib/general";
import { Loader2 } from "lucide-react";

interface AddingExperienceProps {
  experience: AddingExperience;
}

const ActivityPlaceholder: React.FC<AddingExperienceProps> = ({
  experience,
}) => {
  return (
    <div className="z-40 w-full absolute bottom-2 left-0">
      <div className="bg-white/80 backdrop-blur-md rounded-xl py-3 px-4 w-[98%] mx-auto ring-1 ring-neutral-200 ">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center space-x-4">
            <Loader2 className="w-5 h-5 text-neutral-600 2xl:w-5 2xl:h-5 animate-spin" />
            <div className="flex flex-col items-start">
              <p className="text-sm text-neutral-800 font-medium mb-0.5 2xl:text-sm">
                <span className="text-neutral-800 truncate inline-block align-bottom">
                  Adding to itinerary
                </span>
              </p>
              <p className="text-xs text-neutral-500 font-light 2xl:text-xs">
                {experience.name}
              </p>
            </div>
          </div>

          <div className="flex flex-row items-center space-x-2 2xl:space-x-3">
            {experience.image && (
              <img
                src={formatImageUrl(experience.image, "low")}
                alt={experience.name}
                className="w-8 h-8 rounded-md object-cover 2xl:w-10 2xl:h-10"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityPlaceholder;
